import { render, staticRenderFns } from "./cartSvg.vue?vue&type=template&id=5576c64a"
import script from "./cartSvg.vue?vue&type=script&lang=js"
export * from "./cartSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports